import { applyModules } from './content/applyModules';

const leadershipSteps = {
  hi: [
    { title: 'पंचायत का चयन', desc: 'हमारे साझेदार के क्षेत्र में एक पंचायत चुनी जाती है' },
    { title: 'परीक्षा की घोषणा', desc: 'योग्यता-आधारित परीक्षा सार्वजनिक रूप से घोषित होती है' },
    { title: 'लिखित परीक्षा आयोजित', desc: 'पात्र युवाओं की बड़ी संख्या परीक्षा में शामिल होती है' },
    { title: 'शीर्ष 10 शॉर्टलिस्ट', desc: 'सर्वाधिक अंक पाने वाले 10 उम्मीदवार चुने जाते हैं' },
    { title: 'साक्षात्कार से छंटाई', desc: 'अंतिम 3 उम्मीदवार चुने जाते हैं' },
    { title: 'ग्रामीणों के सामने सार्वजनिक बहस', desc: 'गांव के लोग सीधे सवाल पूछते हैं' },
    { title: 'जनता का मतदान', desc: 'जनता तय करती है कि किसे आगे बढ़ाया जाए' },
    { title: 'चुनाव प्रचार', desc: 'शॉर्टलिस्ट किए गए उम्मीदवार के लिए मुखिया/प्रधान पद हेतु पूर्ण प्रचार अभियान चलाया जाता है' },
  ],
  en: [
    { title: 'Panchayat selection', desc: 'One Panchayat is chosen in our partner\'s constituency' },
    { title: 'Exam announcement', desc: 'Merit-based exam is publicly announced' },
    { title: 'Written exam conducted', desc: 'A large number of eligible youth participate in the exam' },
    { title: 'Top 10 shortlisted', desc: 'The 10 highest-scoring candidates are selected' },
    { title: 'Interview screening', desc: 'Final 3 candidates are chosen' },
    { title: 'Public debate before villagers', desc: 'Village residents ask questions directly' },
    { title: 'Public voting', desc: 'The public decides who moves forward' },
    { title: 'Election campaigning', desc: 'Full campaign is run for the shortlisted candidate for Mukhiya/Pradhan position' },
  ],
};

const sponsorJourneySteps = {
  hi: [
    { title: 'पंचायत का चयन', desc: 'BRAHMOID आपके क्षेत्र में एक पंचायत चुनता है' },
    { title: 'परीक्षा की घोषणा', desc: 'योग्यता-आधारित परीक्षा सार्वजनिक रूप से घोषित होती है' },
    { title: 'परीक्षा आयोजित', desc: '500 पात्र युवाओं में से 100 परीक्षा देते हैं' },
    { title: 'शीर्ष 10 शॉर्टलिस्ट', desc: 'सर्वाधिक अंक पाने वाले 10 उम्मीदवार चुने जाते हैं' },
    { title: 'साक्षात्कार से छंटाई', desc: '10 में से अंतिम 3 उम्मीदवार चुने जाते हैं' },
    { title: 'ग्रामीणों के सामने बहस', desc: 'गांव के निवासी सीधे सवाल पूछते हैं' },
    { title: 'जनता चुनती है टॉपर', desc: 'सबसे पसंदीदा उम्मीदवार बनता है विजेता' },
    { title: 'हर पंचायत में दोहराव', desc: 'जितना बड़ा हार का अंतर, उतनी ज़्यादा पंचायतों में यह मॉडल दोहराया जाता है' },
  ],
  en: [
    { title: 'Panchayat selection', desc: 'BRAHMOID selects one Panchayat in your constituency' },
    { title: 'Exam announcement', desc: 'Merit-based exam is publicly announced' },
    { title: 'Exam conducted', desc: '100 out of 500 eligible youth take the exam' },
    { title: 'Top 10 shortlisted', desc: 'The 10 highest-scoring candidates are selected' },
    { title: 'Interview screening', desc: 'Final 3 candidates are chosen from the 10' },
    { title: 'Debate before villagers', desc: 'Village residents ask questions directly' },
    { title: 'Public picks the topper', desc: 'The most preferred candidate becomes the winner' },
    { title: 'Repeat in every Panchayat', desc: 'The larger the margin of defeat, the more Panchayats this model is replicated in' },
  ],
};

export const translations = {
  hi: {
    common: {
      navLeadership: 'नेतृत्व विकास',
      navHyperlocal: 'हाइपरलोकल प्लेटफ़ॉर्म',
      navAbout: 'हमारे बारे में',
      navBlog: 'ब्लॉग',
      blogIntro: 'ज़मीनी राजनीति, पंचायत चुनाव और ग्रामीण नेतृत्व पर हमारी टीम के विश्लेषण।',
      blogReadMore: 'पूरा पढ़ें →',
      blogBack: '← सभी ब्लॉग',
      blogBy: 'लेखक',
      becomeCandidate: 'उम्मीदवार बनें',
      becomeSponsor: 'प्रायोजक बनें',
      becomeCandidateArrow: 'उम्मीदवार बनें ↓',
      becomeSponsorArrow: 'प्रायोजक बनें ↓',
      becomeSponsorLink: 'प्रायोजक बनें →',
      becomeCandidateLink: 'उम्मीदवार बनें →',
      watchDemo: 'डेमो देखें',
      contactUs: 'संपर्क करें',
      privacy: 'गोपनीयता नीति',
      cookies: 'कुकी नीति',
      terms: 'नियम व शर्तें',
      contact: 'संपर्क',
      vertical01: 'वर्टिकल 01',
      vertical02: 'वर्टिकल 02',
      problem01Solution: 'समस्या 01 का समाधान',
      problem02Solution: 'समस्या 02 का समाधान',
      feature: 'फ़ीचर',
      benefit: 'फ़ायदा',
      photo: '[फ़ोटो]',
      choose: 'चुनें...',
      objective: 'उद्देश्य',
      topics: 'मुख्य विषय',
    },
    home: {
      title: 'राजनीति का पुनर्निर्माण, जड़ से',
      p1: 'भारत का लोकतंत्र गांव से शुरू होता है। फिर भी ज़मीनी नेतृत्व अक्सर योग्यता से नहीं, बल्कि पहचान, पार्टी और पैसों के नेटवर्क से तय होता है।',
      p2: 'BRAHMOID दो मोर्चों पर एक साथ काम करती है — योग्य नेतृत्व की खोज, और सत्ता में आने के बाद उनके प्रदर्शन की निगरानी।',
      p3: 'हम पंचायत स्तर पर योग्यता-आधारित उम्मीदवारों की पहचान करते हैं, उन्हें आगे बढ़ाते हैं — और चुनाव जीतने के बाद, अपने हाइपरलोकल सोशल प्लेटफ़ॉर्म के ज़रिए उन्हें हर दिन जवाबदेह बनाए रखते हैं।',
      heroVisual: '[हीरो विज़ुअल — उदा. भारत मैप डॉट पैटर्न / पंचायत तस्वीर / प्रोडक्ट स्क्रीनशॉट कोलाज]',
      problemsTitle: 'भारत की राजनीति में दो कड़ियां टूटी हुई हैं',
      problemsSub: '2 समस्या-कार्ड, हर एक आगे किसी एक वर्टिकल से सीधे जुड़ता है',
      problem1Label: 'समस्या 01 — चुनाव से पहले',
      problem1Title: 'योग्य व्यक्ति तक पहुंचने का कोई रास्ता नहीं',
      problem1Desc: 'हर गांव में सक्षम, ईमानदार युवा मौजूद हैं। लेकिन यह तय कौन करता है कि कौन आगे बढ़ेगा? जाति समीकरण, पार्टी का दबदबा और पैसों का खेल — योग्यता का कोई ढांचागत, निष्पक्ष रास्ता नहीं होता।',
      problem2Label: 'समस्या 02 — चुनाव जीतने के बाद',
      problem2Title: 'जीतते ही जवाबदेही गायब हो जाती है',
      problem2Desc: 'एक बार कुर्सी मिल जाने पर, अगले चुनाव तक कोई हिसाब नहीं मांगता। शिकायतें खो जाती हैं, पैसों की आवाजाही अस्पष्ट रहती है, और काम की गुणवत्ता कोई नहीं मापता।',
      problemsClose: 'BRAHMOID दोनों कड़ियों को एक साथ जोड़ता है।',
      solutionTitle: 'हमारा समाधान: दो वर्टिकल, एक मक़सद',
      solutionSub: 'दोनों कार्ड पूरी तरह क्लिक करने योग्य लिंक हैं — अंदर अलग बटन नहीं',
      leadershipTitle: 'नेतृत्व विकास',
      leadershipDesc: 'हर पंचायत में योग्य उम्मीदवारों की खोज — परीक्षा, साक्षात्कार और सार्वजनिक बहस के ज़रिए — और फिर मुखिया/प्रधान पद के लिए चुनाव प्रचार।',
      hyperlocalTitle: 'हाइपरलोकल सोशल प्लेटफ़ॉर्म',
      hyperlocalDesc: 'पंचायत, विधानसभा और लोकसभा — हर स्तर पर मतदाताओं को उनके प्रतिनिधियों से जोड़ने वाला मंच, जो हर नेता की जवाबदेही तय करता है।',
      solutionClose: 'हमारी सोच सीधी है: पहले सही व्यक्ति को कुर्सी तक पहुंचाओ, फिर सुनिश्चित करो कि कुर्सी पर बैठने के बाद भी वह जनता के प्रति जवाबदेह बना रहे।',
      cta: 'योग्यता से नेतृत्व। जवाबदेही से विकास। जनता के साथ जीत।',
    },
    leadership: {
      title: 'नेतृत्व विकास — जड़ से योग्यता की खोज',
      intro: 'हमारी तलाश गांव से शुरू होती है। हम हर पंचायत में छुपी प्रतिभाओं को खोजते हैं — पढ़े-लिखे युवा, समाजसेवी, और वे लोग जिनके पास नेतृत्व की क्षमता तो है, लेकिन राजनीति में आने का कोई रास्ता नहीं।',
      howTitle: 'कैसे काम करता है',
      howSub: '8-चरण प्रक्रिया — क्षैतिज टाइमलाइन (मोबाइल पर स्टैक्ड कार्ड)',
      steps: leadershipSteps.hi,
      criteriaTitle: 'आकलन के मापदंड',
      writtenExam: 'लिखित परीक्षा',
      writtenItems: ['पंचायती राज व शासन', 'प्रशासन व सरकार', 'ग्रामीण विकास', 'निर्णय-क्षमता व समस्या समाधान', 'नेतृत्व नैतिकता व दृष्टि'],
      interview: 'साक्षात्कार',
      interviewItems: ['संवाद कौशल', 'नेतृत्व क्षमता', 'कार्यक्षमता व नवाचार सोच'],
      syllabusLink: 'पूरा पाठ्यक्रम विवरण सहित — देखें:',
      applyPageLink: '"मुखिया/प्रधान पद हेतु पंजीकरण करें" पेज',
      mlaLink: 'क्या आप MLA/राजनीतिक नेता हैं और अपने क्षेत्र में यह मॉडल शुरू करना चाहते हैं? →',
      sponsorPageLink: '"जानें कैसे / MLA प्रायोजन"',
      effectiveTitle: 'क्यों यह मॉडल असरदार है',
      noCaste: 'जाति नहीं',
      noMoney: 'पैसा नहीं',
      noParty: 'पार्टी नहीं',
      onlyMerit: 'सिर्फ़ योग्यता।',
      meritLine: 'जाति नहीं। पैसा नहीं। पार्टी नहीं। सिर्फ़ योग्यता।',
      effectiveDesc: 'पिछली बार जो भी हुआ — जातीय समीकरण, पार्टी का दबदबा या पैसों का खेल — यह कभी साबित नहीं हुआ कि यही जीत की असली वजह थी। असली ताकत कहीं और छिपी थी: हज़ारों काबिल युवा, जिन्हें राजनीति ने कभी मौका ही नहीं दिया।',
    },
    hyperlocal: {
      title: 'हाइपरलोकल सोशल प्लेटफ़ॉर्म — जवाबदेही, हर दिन',
      intro: 'सिर्फ़ सही व्यक्ति को चुनना काफ़ी नहीं। असली परीक्षा शुरू होती है कुर्सी मिलने के बाद। BRAHMOID का हाइपरलोकल सोशल प्लेटफ़ॉर्म हर निर्वाचन क्षेत्र — पंचायत, विधानसभा और लोकसभा स्तर — पर मतदाताओं को उनके जनप्रतिनिधियों से सीधे जोड़ता है।',
      heroVisual: '[विज़ुअल: प्रोडक्ट डैशबोर्ड स्क्रीनशॉट कोलाज — जवाबदेही स्कोर + शिकायत ट्रैकर + पारदर्शिता लेजर]',
      featuresTitle: 'प्लेटफ़ॉर्म क्या करता है',
      featuresSub: '6 फ़ीचर कार्ड ग्रिड (3x2)',
      features: [
        { title: 'सत्यापित डिजिटल पहचान', desc: 'पंचायत से जुड़े हर व्यक्ति — नेता, ठेकेदार, आपूर्तिकर्ता, मज़दूर, अधिकारी — की पहचान सत्यापित और आपस में जुड़ी होती है। कोई फ़र्ज़ी खाता नहीं, हर कार्रवाई किसी न किसी पहचान से जुड़ी होती है।' },
        { title: 'शिकायत ट्रैकिंग व रूटिंग', desc: 'नागरिक कोई भी समस्या दर्ज करते हैं, सिस्टम उसे स्वतः सही अधिकारी तक पहुंचाता है, और समयबद्ध समाधान न होने पर वह अपने आप अगले स्तर तक एस्केलेट हो जाती है — कोई शिकायत अटकती नहीं।' },
        { title: 'पारदर्शिता लेजर (प्रोएक्टिव RTI)', desc: 'पंचायत खाते से हर रुपये की आवाजाही — ठेकेदार, आपूर्तिकर्ता, मज़दूर तक — रीयल-टाइम में सार्वजनिक और ट्रेस करने योग्य होती है। अब RTI का इंतज़ार नहीं, हर लेन-देन पहले से सार्वजनिक।' },
        { title: 'प्रोजेक्ट रजिस्ट्री', desc: 'हर सरकारी प्रोजेक्ट — सड़क, नाली, स्कूल, पेयजल आदि — की स्थिति, बजट, प्रगति और गुणवत्ता सार्वजनिक रूप से ट्रैक होती है।' },
        { title: 'जवाबदेही स्कोर', desc: 'नागरिकों की रेटिंग, शिकायत समाधान और प्रोजेक्ट प्रदर्शन के आधार पर हर प्रतिनिधि व स्टेकहोल्डर का एक मापने योग्य स्कोर तैयार होता है।' },
        { title: 'सिविक नेटवर्क', desc: 'नागरिक चर्चाओं में भाग लेते हैं, पोल में वोट डालते हैं, और अपने क्षेत्र की प्राथमिकताएं खुद तय करते हैं।' },
      ],
      repBenefitsTitle: 'जनप्रतिनिधि के लिए क्या फ़ायदा',
      engagementHub: 'लीडर इंगेजमेंट हब',
      engagementDesc: 'जनता से सीधा संवाद, घोषणाएं भेजने, बैठकों की सूचना देने और अपने काम को दिखाने के लिए एक ही मंच।',
      dashboardScreenshot: '[डैशबोर्ड स्क्रीनशॉट]',
      aiDashboard: 'AI + पारदर्शिता डैशबोर्ड',
      aiDashboardDesc: 'किस वार्ड में सबसे ज़्यादा असंतोष है, कौन-सी समस्याएं बढ़ रही हैं, और कहां पहले ध्यान देने की ज़रूरत है — यह सब रीयल-टाइम में सामने आता है।',
      accountabilityTitle: 'यह प्लेटफ़ॉर्म किसे जवाबदेह ठहराता है',
      accountabilityItems: ['समस्या समाधान की गति और गुणवत्ता पर', 'योजनाओं व लाभों के वितरण पर', 'सड़क, नाली, स्कूल जैसे बुनियादी ढांचे के कार्यों में ईमानदारी व गुणवत्ता पर'],
      accountabilityNote: '(यह सूची पूर्ण नहीं है — बल्कि प्रमुख उदाहरण मात्र हैं)',
      whyImportantTitle: 'क्यों यह ज़रूरी है',
      whyImportantText: 'चुनाव जीत जाना सिर्फ़ शुरुआत है। BRAHMOID सुनिश्चित करता है कि सत्ता में आने के बाद भी हर जनप्रतिनिधि अपने पूरे कार्यकाल भर जनता के प्रति जवाबदेह बना रहे — न कोई शिकायत खोती है, न कोई नागरिक अनसुना रहता है।',
    },
    about: {
      title: 'BRAHMOID के बारे में',
      intro: 'यह पेज उन लोगों के लिए है जो हमारी पिच सुनने के बाद पूछते हैं — "पर यह कंपनी असल में है क्या, और चलाता कौन है?" नीचे हमारी कानूनी संरचना, सोच और टीम है।',
      homeLinkNote: '(हम क्या करते हैं और क्यों — इसका पूरा परिचय होम पेज पर है, यहां दोहराया नहीं गया है)',
      legalTitle: 'कानूनी संरचना व पारदर्शिता',
      legalItems: [
        'BRAHMOID Pvt. Ltd.',
        'Chaar Murti, A-905, Tower T3, NXONE Business Tower, Plot No. 17, near Gaur Chowk, Tech Zone IV, Greater Noida, Uttar Pradesh 201318',
        'राजस्व स्रोत: प्रायोजन शुल्क (MLA/नेता द्वारा) — कोई सरकारी अनुदान या दान नहीं लिया जाता',
      ],
      legalLinkPrefix: 'उम्मीदवार चयन प्रक्रिया व निर्णायक मंडल में सार्वजनिक भागीदारी सुनिश्चित है (देखें:',
      legalLinkSuffix: ')',
      beliefsTitle: 'हमारी सोच',
      beliefs: ['नेतृत्व बनाया जाता है, माना नहीं जाता', 'शासन की शुरुआत जड़ से होती है', 'राजनीतिक विश्वसनीयता दिखने वाले सार्वजनिक काम से बनती है', 'मज़बूत स्थानीय संस्थाएं राष्ट्रीय लोकतंत्र को मज़बूत करती हैं'],
      teamTitle: 'टीम',
      team: [
        { name: 'Anurag', role: 'CEO', linkedin: 'https://www.linkedin.com/in/anu2atom/', photo: null },
        { name: 'Ishaan', role: 'CTO', linkedin: 'https://www.linkedin.com/in/ishaanhere/', photo: null },
        { name: 'Aayush', role: 'CMO', linkedin: 'https://www.linkedin.com/in/mraayush11/', photo: null },
        { name: 'Ghanshyam', role: 'COO', linkedin: 'https://www.linkedin.com/in/ghanshyam-sharma-77ab66121/', photo: null },
      ],
    },
    footer: {
      address: 'Chaar Murti, A-905, Tower T3, NXONE Business Tower, Plot No. 17, near Gaur Chowk, Tech Zone IV, Greater Noida, Uttar Pradesh 201318',
      phone: '6299621442',
      email: 'founder@brahmoid.org',
    },
    sponsor: {
      eyebrow: 'MLA / राजनीतिक नेताओं के लिए',
      title: 'हार से जीत तक',
      intro: 'योग्यता से बनी एक नई राजनीतिक राह — पंचायत चुनाव व सहयोग योजना',
      lastTimeTitle: 'पिछली बार क्या हुआ?',
      lastTimeDesc: 'आप पूरी ताकत से लड़े, फिर भी दूसरे स्थान पर रह गए।',
      casteCalc: 'जातीय समीकरण',
      partyDominance: 'पार्टी का दबदबा',
      moneyGame: 'पैसों का खेल',
      darkBanner: 'पर आज तक यह साबित नहीं हुआ कि यही असली वजह थी।',
      darkBannerSub: '(शायद कुछ और भी था — जिसे कभी आज़माया ही नहीं गया)',
      hiddenStrengthTitle: 'असली ताकत, कहीं और छिपी थी',
      youthIcon: 'हज़ारों काबिल युवा',
      youthDesc1: 'पढ़े-लिखे, योग्य युवा आज भी बेरोज़गार बैठे हैं। राजनीति ने उन्हें कभी मौका ही नहीं दिया।',
      youthDesc2: 'यही वह ताकत है, जिसे अब तक किसी ने नहीं आज़माया।',
      meritLine: 'जाति नहीं। पैसा नहीं। पार्टी नहीं। सिर्फ़ योग्यता।',
      meritFormula: 'BRAHMOID लाया है एक बिल्कुल नया फॉर्मूला — जो पुरानी राजनीति को पीछे छोड़ देगा।',
      journeyTitle: 'एक पंचायत की पूरी यात्रा',
      journeySub: 'चरण दर चरण — और इसे हर पंचायत में दोहराने की रणनीति',
      journeySteps: sponsorJourneySteps.hi,
      journeyClose: 'जो सबसे योग्य, वही बने पंचायत का भावी नेता — और यही यात्रा, हर पंचायत में दोहराई जाती है।',
      meritTestTitle: 'योग्यता की कसौटी',
      meritWrittenItems: ['पंचायत विकास', 'भ्रष्टाचार के मुद्दे', 'स्थानीय समस्याएं'],
      panelNote: 'निर्णायक मंडल में रहेंगे आप स्वयं भी',
      panelDesc: '— 4–5 निर्णायकों के पैनल में आपकी सीधी भागीदारी, शुरुआत से ही जुड़ाव।',
      publicForumTitle: 'जनता के सामने, जनता के लिए',
      publicForumDesc: 'अंतिम 3 उम्मीदवार सार्वजनिक मंच पर (पार्क, मैदान या हॉल में) → निर्णायक व जनता के सवाल (भ्रष्टाचार, दृष्टिकोण, विकास योजना) → जनता का मतदान (व्हाट्सएप द्वारा) → विजेता घोषित',
      publicForumClose: 'जिसे जनता चुने, वही बने विजेता।',
      realGameTitle: 'अब शुरू होता है असली खेल',
      realGameItems: ['BRAHMOID का आधिकारिक सरपंच प्रत्याशी', 'राजस्थान में 2 महीने में पंचायत चुनाव', 'पूरे चुनाव प्रचार में BRAHMOID का साथ'],
      realGameClose: 'एक साधारण युवा, अब बनेगा कल का नेता।',
      scaleTitle: 'एक पंचायत से, पूरे निर्वाचन क्षेत्र तक',
      scaleSub: 'जितनी पंचायतें, उतना बड़ा जनाधार।',
      tableProgram: 'कार्यक्रम',
      tablePanchayats: 'पंचायतें',
      tableInvestment: 'निवेश',
      tableRows: [
        { program: 'शुरुआत', panchayats: '5 पंचायतें', investment: '₹7,50,000' },
        { program: 'विस्तार', panchayats: '15 पंचायतें', investment: '₹22,50,000' },
        { program: 'पूरा क्षेत्र', panchayats: 'सभी पंचायतें', investment: 'आवश्यकतानुसार' },
      ],
      perPanchayat: 'प्रति पंचायत निवेश: ₹1,50,000 (परीक्षा, चयन एवं प्रचार सहयोग सहित)',
      sarpanchNetwork: 'हर जीता हुआ सरपंच, आपके लिए एक भरोसेमंद स्थानीय नेटवर्क बनता है।',
      accountabilityEngineTitle: 'काम कराएगा कौन? — BRAHMOID का जवाबदेही इंजन',
      accountabilityEngineSteps: [
        'नया सरपंच काम शुरू करता है → हर शिकायत व काम मंच पर दर्ज होता है → हर वार्ड की समस्या तुरंत पहचानी जाती है',
        'यह जानकारी सीधे आपको मिलती है → आप समय पर पहुंचकर भरोसा जीतते हैं',
      ],
      accountabilityEngineClose: 'नया नेतृत्व मजबूरन काम करेगा — और हर सुधार की खबर सबसे पहले आपके पास होगी।',
      nameWithWinsTitle: 'आपका नाम, हर जीत के साथ',
      nameWithWinsItems: [
        'प्रचार सामग्री पर आपका समर्थन दर्ज होता है',
        'सार्वजनिक मंच व मीडिया में आपकी भागीदारी होती है',
        'ग्राम सभाओं में आपको सम्मानित अतिथि बुलाया जाता है',
        'BRAHMOID की रिपोर्ट में आपके योगदान का उल्लेख होता है',
      ],
      nameWithWinsClose: 'हर सफलता की कहानी में, शुरुआत से जुड़ा रहेगा आपका नाम।',
      benefitsTitle: 'प्रायोजक को क्या मिलता है?',
      benefits: [
        { title: 'छवि निर्माण — युवा सशक्तिकरण के प्रणेता के रूप में', desc: 'प्रचार सामग्री, सार्वजनिक मंच और मीडिया कवरेज में आपको उस व्यक्ति के रूप में दिखाया जाता है जिसने बेरोज़गार, योग्य युवाओं को राजनीति में मौका दिया — जाति या पैसे के बिना।' },
        { title: 'हर ग्राम सभा में सम्मानित आमंत्रण', desc: 'जीता हुआ मुखिया/प्रधान अपनी हर ग्राम सभा बैठक में आपको विशेष अतिथि के रूप में आमंत्रित करता है — निरंतर, दृश्यमान उपस्थिति बिना बार-बार मांगे।' },
        { title: 'विकास का साझा श्रेय', desc: 'हमारा जवाबदेही इंजन सुनिश्चित करता है कि मुखिया मेहनत से काम करे। जो भी विकास होता है, उसका श्रेय — आपके समर्थन की वजह से — आंशिक रूप से आपको भी मिलता है।' },
      ],
      dashboardTitle: 'फ़ायदा 04 — लीडर डैशबोर्ड',
      dashboardSub: 'प्रायोजकों / भावी विधायकों के लिए इंटेलिजेंस लेयर — सत्ताधारी विधायक तक पहुंचने से पहले ही आपको मिलती है रीयल-टाइम जानकारी।',
      dashboardNote: '(यह हाइपरलोकल सोशल प्लेटफ़ॉर्म वर्टिकल का हिस्सा है — पूरा विवरण उस पेज पर भी है)',
      dashboardFeatures: [
        { title: 'प्रोएक्टिव रिस्क मैनेजमेंट', items: ['कमज़ोर होते शासन व घटते जनसमर्थन को समय रहते पहचानें', 'जहां ज़रूरत हो, वहां संसाधन व नेतृत्व को प्राथमिकता दें'] },
        { title: 'वोटर सेंटिमेंट इंटेलिजेंस', items: ['जनभावना में बदलाव को शुरुआत में ही पहचानें', 'चुनाव पर असर पड़ने से पहले प्रमुख मतदाता चिंताओं का समाधान करें'] },
        { title: 'अर्ली इश्यू रिज़ॉल्यूशन', items: ['स्थानीय मुद्दों व तनाव को शुरुआत में पहचानें', 'बड़ा जोखिम बनने से पहले तेज़ी से समाधान करें'] },
        { title: 'डेटा-ड्रिवन एग्ज़िक्यूशन', items: ['रीयल-टाइम इनसाइट्स से सूचित निर्णय लें', 'संसाधनों को कुशलता से तैनात करें, ज़मीनी हकीकत के अनुरूप बने रहें'] },
      ],
      dashboardDesc: 'यानी डैशबोर्ड आपकी पूरी निर्वाचन क्षेत्र की तस्वीर देता है — कौन-सा इलाका विकास में पिछड़ रहा है, समाज का कौन-सा वर्ग किन फ़ैसलों से नाराज़ है, कहां नए मुद्दे उभर रहे हैं — सिर्फ़ प्रायोजित पंचायत तक सीमित नहीं।',
      cta: 'योग्यता, जवाबदेही और जनसंपर्क — यही है जीत का नया रास्ता।',
      formTitle: 'MLA प्रायोजन कार्यक्रम में रुचि — फ़ॉर्म',
      formBasicInfo: 'मूल जानकारी',
      formSuccess: 'धन्यवाद! आपका अनुरोध प्राप्त हो गया है। हमारी टीम समीक्षा कर संपर्क करेगी।',
      formFullName: 'पूरा नाम',
      formParty: 'राजनीतिक दल / संगठन — वैकल्पिक',
      formRole: 'पद / भूमिका',
      formState: 'राज्य',
      formDistrict: 'ज़िला / निर्वाचन क्षेत्र',
      formEmail: 'ईमेल पता',
      formPhone: 'फ़ोन नंबर',
      formProgram: 'आप किस कार्यक्रम में रुचि रखते हैं?',
      formProgramStarter: 'शुरुआती कार्यक्रम (5–10 पंचायतें)',
      formProgramExpansion: 'विस्तार कार्यक्रम (10–15 पंचायतें)',
      formProgramFull: 'पूर्ण क्षेत्र कार्यक्रम (20–30 पंचायतें)',
      formArea: 'आप कहां यह कार्यक्रम शुरू करना चाहते हैं? — ज़िला / निर्वाचन क्षेत्र',
      formMessage: 'अपने क्षेत्र में पंचायत नेतृत्व मजबूत करने की अपनी रुचि के बारे में बताएं — वैकल्पिक',
      formSubmit: 'प्रायोजन अनुरोध भेजें',
      formFooter: 'आपका अनुरोध प्राप्त होने के बाद हमारी टीम इसकी समीक्षा करेगी और चर्चा तय करने के लिए संपर्क करेगी। सीधे संपर्क करना चाहते हैं? Email: founder@brahmoid.org',
    },
    apply: {
      title: 'मुखिया / प्रधान पद हेतु पंजीकरण करें',
      intro: 'क्या आप पढ़े-लिखे, योग्य हैं और अपने गांव के लिए कुछ करना चाहते हैं? BRAHMOID का नेतृत्व मूल्यांकन कार्यक्रम आपको मुखिया/प्रधान पद तक पहुंचने का एक निष्पक्ष, योग्यता-आधारित रास्ता देता है — बिना जाति, पैसे या पार्टी के सहारे के।',
      processTitle: 'चयन प्रक्रिया',
      processSteps: ['लिखित परीक्षा', 'साक्षात्कार', 'सार्वजनिक बहस', 'जनता का मतदान', 'चुनाव प्रचार में पूरा साथ'],
      syllabusTitle: 'पाठ्यक्रम (विस्तृत मूल्यांकन)',
      syllabusSub: '6 मॉड्यूल — एकॉर्डियन लेआउट (मोबाइल पर एकॉर्डियन बेहतर)',
      modules: applyModules.hi,
      sponsorLink: 'यह पूरी प्रक्रिया कौन प्रायोजित/फंड करता है? →',
      sponsorPageLink: '"जानें कैसे / MLA प्रायोजन"',
      outcomesTitle: 'सीखने के परिणाम',
      outcomesIntro: 'कार्यक्रम के अंत तक, उम्मीदवार निम्न से लैस होंगे:',
      outcomes: [
        { title: 'ज्ञान', desc: 'पंचायती राज व्यवस्था, शासन ढांचे व कानूनी ज़िम्मेदारियों की समझ' },
        { title: 'कौशल', desc: 'स्थितियों का विश्लेषण, संसाधनों की योजना, स्पष्ट संवाद' },
        { title: 'समस्या-समाधान क्षमता', desc: 'ढांचागत दृष्टिकोण से पंचायत की वास्तविक चुनौतियां हल करना' },
        { title: 'नेतृत्व मानसिकता', desc: 'सत्यनिष्ठा, निष्पक्षता व जवाबदेही के साथ नेतृत्व' },
        { title: 'नैतिक व ज़िम्मेदार निर्णय-क्षमता', desc: 'हितों के टकराव से बचना, पारदर्शी रहना' },
        { title: 'प्रभावशाली दृष्टि', desc: 'विकसित व आत्मनिर्भर पंचायत का दीर्घकालिक दृष्टिकोण' },
      ],
      outcomesNote: 'आवेदनों की समीक्षा समय-समय पर की जाती है। चुने गए प्रतिभागियों को अगले मूल्यांकन चक्र में शामिल होने हेतु आमंत्रित किया जा सकता है।',
      formTitle: 'पंजीकरण फ़ॉर्म',
      formBasicInfo: 'मूल जानकारी',
      formExtraInfo: 'अतिरिक्त जानकारी',
      formSuccess: 'धन्यवाद! आपका पंजीकरण प्राप्त हो गया है। चुने गए प्रतिभागियों को अगले मूल्यांकन चक्र हेतु आमंत्रित किया जा सकता है।',
      formFullName: 'पूरा नाम',
      formAge: 'आयु',
      formEducation: 'शिक्षा',
      formMobile: 'मोबाइल नंबर',
      formEmail: 'ईमेल पता',
      formState: 'राज्य',
      formDistrict: 'ज़िला',
      formPanchayat: 'पंचायत / गांव का नाम',
      formSocialWork: 'क्या आप पहले किसी सामाजिक/सामुदायिक कार्य में शामिल रहे हैं? — वैकल्पिक',
      formMotivation: 'आप मुखिया/प्रधान क्यों बनना चाहते हैं? — संक्षिप्त संदेश',
      formSubmit: 'पंजीकरण जमा करें',
    },
  },
  en: {
    common: {
      navLeadership: 'Leadership Development',
      navHyperlocal: 'Hyperlocal Platform',
      navAbout: 'About Us',
      navBlog: 'Blog',
      blogIntro: 'Analysis from our team on grassroots politics, Panchayat elections, and rural leadership.',
      blogReadMore: 'Read more →',
      blogBack: '← All blogs',
      blogBy: 'By',
      becomeCandidate: 'Become a Candidate',
      becomeSponsor: 'Become a Sponsor',
      becomeCandidateArrow: 'Become a Candidate ↓',
      becomeSponsorArrow: 'Become a Sponsor ↓',
      becomeSponsorLink: 'Become a Sponsor →',
      becomeCandidateLink: 'Become a Candidate →',
      watchDemo: 'Watch Demo',
      contactUs: 'Contact Us',
      privacy: 'Privacy Policy',
      cookies: 'Cookie Policy',
      terms: 'Terms of Use',
      contact: 'Contact',
      vertical01: 'Vertical 01',
      vertical02: 'Vertical 02',
      problem01Solution: 'Solution to Problem 01',
      problem02Solution: 'Solution to Problem 02',
      feature: 'Feature',
      benefit: 'Benefit',
      photo: '[Photo]',
      choose: 'Choose...',
      objective: 'Objective',
      topics: 'Key topics',
    },
    home: {
      title: 'Rebuilding Politics from the Ground Up',
      p1: "India's democracy begins at the village. Yet grassroots leadership is often determined not by merit, but by identity, party, and money networks.",
      p2: 'Brahmoid works on two fronts simultaneously — finding qualified leadership, and monitoring their performance after they come to power.',
      p3: 'We identify merit-based candidates at the Panchayat level, nurture them — and after they win elections, keep them accountable every day through our hyperlocal social platform.',
      heroVisual: '[Hero visual — e.g. India map dot pattern / Panchayat photo / product screenshot collage]',
      problemsTitle: 'Two links in Indian politics are broken',
      problemsSub: '2 problem cards, each connecting directly to one vertical below',
      problem1Label: 'Problem 01 — Before the election',
      problem1Title: 'No path for qualified individuals to rise',
      problem1Desc: 'Every village has capable, honest youth. But who decides who moves forward? Caste equations, party dominance, and money games — there is no structural, fair path based on merit.',
      problem2Label: 'Problem 02 — After winning the election',
      problem2Title: 'Accountability disappears once elected',
      problem2Desc: 'Once in office, no one asks for accountability until the next election. Complaints are lost, money flows remain opaque, and no one measures the quality of work.',
      problemsClose: 'BRAHMOID connects both links together.',
      solutionTitle: 'Our solution: Two verticals, one purpose',
      solutionSub: 'Both cards are fully clickable links — no separate buttons inside',
      leadershipTitle: 'Leadership Development',
      leadershipDesc: 'Finding qualified candidates in every Panchayat — through exams, interviews, and public debates — and then election campaigning for Mukhiya/Pradhan positions.',
      hyperlocalTitle: 'Hyperlocal Social Platform',
      hyperlocalDesc: 'A platform connecting voters to their representatives at every level — Panchayat, Assembly, and Parliament — that holds every leader accountable.',
      solutionClose: 'Our thinking is simple: first get the right person to the chair, then ensure they remain accountable to the public even after sitting in it.',
      cta: 'Leadership through merit. Development through accountability. Victory with the people.',
    },
    leadership: {
      title: 'Leadership Development — Finding Merit from the Roots',
      intro: 'Our search begins at the village. We find hidden talent in every Panchayat — educated youth, social workers, and those with leadership potential but no path into politics.',
      howTitle: 'How it works',
      howSub: '8-step process — horizontal timeline (stacked cards on mobile)',
      steps: leadershipSteps.en,
      criteriaTitle: 'Assessment criteria',
      writtenExam: 'Written exam',
      writtenItems: ['Panchayati Raj & governance', 'Administration & government', 'Rural development', 'Decision-making & problem solving', 'Leadership ethics & vision'],
      interview: 'Interview',
      interviewItems: ['Communication skills', 'Leadership capacity', 'Efficiency & innovative thinking'],
      syllabusLink: 'Full syllabus with details — see:',
      applyPageLink: '"Register for Mukhiya/Pradhan position" page',
      mlaLink: 'Are you an MLA/political leader wanting to launch this model in your area? →',
      sponsorPageLink: '"Learn How / MLA Sponsorship"',
      effectiveTitle: 'Why this model works',
      noCaste: 'No caste',
      noMoney: 'No money',
      noParty: 'No party',
      onlyMerit: 'Only merit.',
      meritLine: 'No caste. No money. No party. Only merit.',
      effectiveDesc: 'Whatever happened last time — caste equations, party dominance, or money games — it was never proven that these were the real reasons for victory. The real strength lay elsewhere: thousands of capable youth whom politics never gave a chance.',
    },
    hyperlocal: {
      title: 'Hyperlocal Social Platform — Accountability, Every Day',
      intro: "Choosing the right person is not enough. The real test begins after they get the chair. BRAHMOID's hyperlocal social platform connects voters directly to their representatives in every constituency — at Panchayat, Assembly, and Parliament level.",
      heroVisual: '[Visual: Product dashboard screenshot collage — accountability score + complaint tracker + transparency ledger]',
      featuresTitle: 'What the platform does',
      featuresSub: '6 feature cards in a 3x2 grid',
      features: [
        { title: 'Verified digital identity', desc: 'Every person connected to the Panchayat — leader, contractor, supplier, worker, official — has verified and interconnected identity. No fake accounts; every action is tied to an identity.' },
        { title: 'Complaint tracking & routing', desc: 'Citizens register any issue; the system automatically routes it to the right official, and if not resolved in time, it escalates to the next level — no complaint gets stuck.' },
        { title: 'Transparency ledger (Proactive RTI)', desc: 'Every rupee flowing from the Panchayat account — to contractors, suppliers, workers — is public and traceable in real time. No waiting for RTI; every transaction is already public.' },
        { title: 'Project registry', desc: 'Status, budget, progress, and quality of every government project — roads, drains, schools, water supply, etc. — is publicly tracked.' },
        { title: 'Accountability score', desc: 'A measurable score for every representative and stakeholder based on citizen ratings, complaint resolution, and project performance.' },
        { title: 'Civic network', desc: 'Citizens participate in discussions, vote in polls, and set their own priorities for their area.' },
      ],
      repBenefitsTitle: 'Benefits for public representatives',
      engagementHub: 'Leader Engagement Hub',
      engagementDesc: 'One platform for direct communication with the public, sending announcements, meeting notifications, and showcasing your work.',
      dashboardScreenshot: '[Dashboard screenshot]',
      aiDashboard: 'AI + Transparency Dashboard',
      aiDashboardDesc: 'Which ward has the most dissatisfaction, which problems are growing, and where attention is needed first — all visible in real time.',
      accountabilityTitle: 'Who this platform holds accountable',
      accountabilityItems: ['On speed and quality of problem resolution', 'On delivery of schemes and benefits', 'On honesty and quality in basic infrastructure work like roads, drains, and schools'],
      accountabilityNote: '(This list is not exhaustive — key examples only)',
      whyImportantTitle: 'Why this matters',
      whyImportantText: 'Winning the election is just the beginning. BRAHMOID ensures that even after coming to power, every representative remains accountable to the public throughout their entire term — no complaint is lost, no citizen goes unheard.',
    },
    about: {
      title: 'About BRAHMOID',
      intro: 'This page is for those who ask after hearing our pitch — "But does this company actually exist, and who runs it?" Below is our legal structure, philosophy, and team.',
      homeLinkNote: '(The full introduction to what we do and why is on the home page, not repeated here)',
      legalTitle: 'Legal structure & transparency',
      legalItems: [
        'BRAHMOID Pvt. Ltd.',
        'Chaar Murti, A-905, Tower T3, NXONE Business Tower, Plot No. 17, near Gaur Chowk, Tech Zone IV, Greater Noida, Uttar Pradesh 201318',
        'Revenue source: Sponsorship fees (by MLA/leader) — no government grants or donations accepted',
      ],
      legalLinkPrefix: 'Public participation in candidate selection and judging panel is ensured (see:',
      legalLinkSuffix: ')',
      beliefsTitle: 'Our beliefs',
      beliefs: ['Leadership is built, not assumed', 'Governance begins at the roots', 'Political credibility is earned through visible public work', 'Strong local institutions strengthen national democracy'],
      teamTitle: 'Team',
      team: [
        { name: 'Anurag', role: 'CEO', linkedin: 'https://www.linkedin.com/in/anu2atom/', photo: null },
        { name: 'Ishaan', role: 'CTO', linkedin: 'https://www.linkedin.com/in/ishaanhere/', photo: null },
        { name: 'Aayush', role: 'CMO', linkedin: 'https://www.linkedin.com/in/mraayush11/', photo: null },
        { name: 'Ghanshyam', role: 'COO', linkedin: 'https://www.linkedin.com/in/ghanshyam-sharma-77ab66121/', photo: null },
      ],
    },
    footer: {
      address: 'Chaar Murti, A-905, Tower T3, NXONE Business Tower, Plot No. 17, near Gaur Chowk, Tech Zone IV, Greater Noida, Uttar Pradesh 201318',
      phone: '6299621442',
      email: 'founder@brahmoid.org',
    },
    sponsor: {
      eyebrow: 'For MLAs / Political Leaders',
      title: 'From Defeat to Victory',
      intro: 'A new political path built on merit — Panchayat elections and collaboration program',
      lastTimeTitle: 'What happened last time?',
      lastTimeDesc: 'You fought with full force, yet finished second.',
      casteCalc: 'Caste equations',
      partyDominance: 'Party dominance',
      moneyGame: 'Money games',
      darkBanner: 'But it has never been proven that these were the real reasons.',
      darkBannerSub: '(Perhaps there was something else — that was never even tried)',
      hiddenStrengthTitle: 'The real strength was hidden elsewhere',
      youthIcon: 'Thousands of capable youth',
      youthDesc1: 'Educated, qualified youth still sit unemployed. Politics never gave them a chance.',
      youthDesc2: 'This is the strength that no one has tried yet.',
      meritLine: 'No caste. No money. No party. Only merit.',
      meritFormula: 'BRAHMOID brings a completely new formula — one that will leave old politics behind.',
      journeyTitle: 'The full journey of one Panchayat',
      journeySub: 'Step by step — and the strategy to repeat it in every Panchayat',
      journeySteps: sponsorJourneySteps.en,
      journeyClose: 'The most qualified becomes the Panchayat\'s future leader — and this journey is repeated in every Panchayat.',
      meritTestTitle: 'The test of merit',
      meritWrittenItems: ['Panchayat development', 'Corruption issues', 'Local problems'],
      panelNote: 'You will be on the judging panel yourself',
      panelDesc: '— direct participation in a panel of 4–5 judges, engaged from the start.',
      publicForumTitle: 'Before the public, for the public',
      publicForumDesc: 'Final 3 candidates on a public stage (park, ground, or hall) → questions from judges and public (corruption, vision, development plan) → public voting (via WhatsApp) → winner announced',
      publicForumClose: 'Whoever the public chooses, becomes the winner.',
      realGameTitle: 'Now the real game begins',
      realGameItems: ['BRAHMOID\'s official Sarpanch candidate', 'Panchayat elections in Rajasthan in 2 months', 'BRAHMOID\'s support throughout the entire election campaign'],
      realGameClose: 'An ordinary youth will now become tomorrow\'s leader.',
      scaleTitle: 'From one Panchayat to the entire constituency',
      scaleSub: 'More Panchayats, bigger public base.',
      tableProgram: 'Program',
      tablePanchayats: 'Panchayats',
      tableInvestment: 'Investment',
      tableRows: [
        { program: 'Starter', panchayats: '5 Panchayats', investment: '₹7,50,000' },
        { program: 'Expansion', panchayats: '15 Panchayats', investment: '₹22,50,000' },
        { program: 'Full constituency', panchayats: 'All Panchayats', investment: 'As required' },
      ],
      perPanchayat: 'Per Panchayat investment: ₹1,50,000 (including exam, selection, and campaign support)',
      sarpanchNetwork: 'Every winning Sarpanch becomes a trusted local network for you.',
      accountabilityEngineTitle: 'Who will make them work? — BRAHMOID\'s accountability engine',
      accountabilityEngineSteps: [
        'New Sarpanch starts work → every complaint and task is recorded on the platform → every ward\'s problem is instantly identified',
        'This information reaches you directly → you arrive in time and win trust',
      ],
      accountabilityEngineClose: 'The new leadership will be compelled to work — and you\'ll hear about every improvement first.',
      nameWithWinsTitle: 'Your name, with every victory',
      nameWithWinsItems: [
        'Your support is recorded on campaign materials',
        'You participate in public forums and media',
        'You are invited as an honored guest at Gram Sabhas',
        'Your contribution is mentioned in BRAHMOID reports',
      ],
      nameWithWinsClose: 'In every success story, your name will be linked from the start.',
      benefitsTitle: 'What does the sponsor get?',
      benefits: [
        { title: 'Image building — as a champion of youth empowerment', desc: 'In campaign materials, public forums, and media coverage, you are shown as the person who gave unemployed, qualified youth a chance in politics — without caste or money.' },
        { title: 'Honored invitation at every Gram Sabha', desc: 'The winning Mukhiya/Pradhan invites you as a special guest to every Gram Sabha meeting — continuous, visible presence without having to ask repeatedly.' },
        { title: 'Shared credit for development', desc: 'Our accountability engine ensures the Mukhiya works hard. Whatever development happens, you partially receive credit — because of your support.' },
      ],
      dashboardTitle: 'Benefit 04 — Leader Dashboard',
      dashboardSub: 'Intelligence layer for sponsors / prospective MLAs — real-time information before even reaching the ruling MLA.',
      dashboardNote: '(This is part of the Hyperlocal Social Platform vertical — full details are also on that page)',
      dashboardFeatures: [
        { title: 'Proactive Risk Management', items: ['Identify weakening governance and declining public support in time', 'Prioritize resources and leadership where needed'] },
        { title: 'Voter Sentiment Intelligence', items: ['Detect shifts in public mood early', 'Address major voter concerns before they affect elections'] },
        { title: 'Early Issue Resolution', items: ['Identify local issues and tensions early', 'Resolve quickly before they become major risks'] },
        { title: 'Data-Driven Execution', items: ['Make informed decisions from real-time insights', 'Deploy resources efficiently, staying grounded in reality'] },
      ],
      dashboardDesc: 'The dashboard gives you a picture of your entire constituency — which area is lagging in development, which social group is upset with which decisions, where new issues are emerging — not limited to sponsored Panchayats alone.',
      cta: 'Merit, accountability, and public connect — this is the new path to victory.',
      formTitle: 'Interest in MLA Sponsorship Program — Form',
      formBasicInfo: 'Basic information',
      formSuccess: 'Thank you! Your request has been received. Our team will review and contact you.',
      formFullName: 'Full name',
      formParty: 'Political party / organization — optional',
      formRole: 'Position / role',
      formState: 'State',
      formDistrict: 'District / constituency',
      formEmail: 'Email address',
      formPhone: 'Phone number',
      formProgram: 'Which program are you interested in?',
      formProgramStarter: 'Starter program (5–10 Panchayats)',
      formProgramExpansion: 'Expansion program (10–15 Panchayats)',
      formProgramFull: 'Full constituency program (20–30 Panchayats)',
      formArea: 'Where would you like to start this program? — District / constituency',
      formMessage: 'Tell us about your interest in strengthening Panchayat leadership in your area — optional',
      formSubmit: 'Submit sponsorship request',
      formFooter: 'After receiving your request, our team will review it and contact you to schedule a discussion. Want to reach out directly? Email: founder@brahmoid.org',
    },
    apply: {
      title: 'Register for Mukhiya / Pradhan position',
      intro: 'Are you educated, qualified, and want to do something for your village? BRAHMOID\'s leadership assessment program gives you a fair, merit-based path to the Mukhiya/Pradhan position — without caste, money, or party backing.',
      processTitle: 'Selection process',
      processSteps: ['Written exam', 'Interview', 'Public debate', 'Public voting', 'Full support in election campaigning'],
      syllabusTitle: 'Syllabus (detailed assessment)',
      syllabusSub: '6 modules — accordion layout (accordion works better on mobile)',
      modules: applyModules.en,
      sponsorLink: 'Who sponsors/funds this entire process? →',
      sponsorPageLink: '"Learn How / MLA Sponsorship"',
      outcomesTitle: 'Learning outcomes',
      outcomesIntro: 'By the end of the program, candidates will be equipped with:',
      outcomes: [
        { title: 'Knowledge', desc: 'Understanding of Panchayati Raj system, governance structure, and legal responsibilities' },
        { title: 'Skills', desc: 'Analyzing situations, planning resources, clear communication' },
        { title: 'Problem-solving ability', desc: 'Solving real Panchayat challenges with a structural approach' },
        { title: 'Leadership mindset', desc: 'Leading with integrity, fairness, and accountability' },
        { title: 'Ethical & responsible decision-making', desc: 'Avoiding conflicts of interest, staying transparent' },
        { title: 'Impactful vision', desc: 'Long-term vision for a developed and self-reliant Panchayat' },
      ],
      outcomesNote: 'Applications are reviewed periodically. Selected participants may be invited for the next assessment cycle.',
      formTitle: 'Registration form',
      formBasicInfo: 'Basic information',
      formExtraInfo: 'Additional information',
      formSuccess: 'Thank you! Your registration has been received. Selected participants may be invited for the next assessment cycle.',
      formFullName: 'Full name',
      formAge: 'Age',
      formEducation: 'Education',
      formMobile: 'Mobile number',
      formEmail: 'Email address',
      formState: 'State',
      formDistrict: 'District',
      formPanchayat: 'Panchayat / village name',
      formSocialWork: 'Have you been involved in any social/community work before? — optional',
      formMotivation: 'Why do you want to become Mukhiya/Pradhan? — brief message',
      formSubmit: 'Submit registration',
    },
  },
};
